import React, { FC } from 'react'

import { Column } from '../../../components'

import { FeaturesDetailsBlockOption } from '../features-details-block-option'

import { ProductFeaturesProps } from './product-features.types'
import { useStyle } from './product-features.styles'

export const ProductFeatures: FC<ProductFeaturesProps> = ({
  className = '',
  product
}) => {
  const classes = useStyle()

  const {
    brandName,
    productionDaysUpTo,
    countryOfOrigin,
    materialCare,
    materialComposition
  } = product

  return (
    <Column
      alignItems="flex-start"
      justifyContent="flex-start"
      fullWidth
      className={className}
    >
      <FeaturesDetailsBlockOption
        className={classes.optionsRow}
        label="Production days up to:"
        labelTx="product.features.details.production.days"
        text={String(productionDaysUpTo) || '-'}
      />
      <FeaturesDetailsBlockOption
        className={classes.optionsRow}
        label="Brand name:"
        labelTx="product.features.details.brand.name"
        text={brandName || '-'}
      />
      <FeaturesDetailsBlockOption
        className={classes.optionsRow}
        label="Country of Origin:"
        text={countryOfOrigin || '-'}
      />
      <FeaturesDetailsBlockOption
        className={classes.optionsRow}
        label="Material composition:"
        labelTx="product.features.details.material.composition"
        text={materialComposition || '-'}
      />
      <FeaturesDetailsBlockOption
        className={classes.optionsRow}
        label="Material care:"
        labelTx="product.features.details.material.care"
        text={materialCare || '-'}
      />
    </Column>
  )
}
